import React from 'react';

const LeftArrowIcon = () => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6001 13.1999L8.4001 8.3999L8.4001 17.9999L15.6001 13.1999Z"
        fill="white"
      />
    </svg>
  );
};

export default LeftArrowIcon;